'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

require('./TabbedNavigation.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tab = function Tab(_ref) {
    var route = _ref.route,
        title = _ref.title,
        active = _ref.active;
    return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
            _reactRouter.Link,
            { to: route, className: (0, _classnames2.default)('Tab', { active: active }) },
            title
        )
    );
};

Tab.propTypes = {
    route: _propTypes2.default.string,
    title: _propTypes2.default.string,
    active: _propTypes2.default.bool
};

var TabbedNavigation = function TabbedNavigation(_ref2) {
    var tabs = _ref2.tabs,
        children = _ref2.children,
        className = _ref2.className,
        location = _ref2.location;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('TabbedNavigation', className) },
        _react2.default.createElement(
            'nav',
            { className: 'tabs' },
            _react2.default.createElement(
                'ul',
                null,
                tabs.map(function (tab) {
                    return _react2.default.createElement(Tab, _extends({}, tab, { key: tab.route, active: location.pathname === tab.route }));
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'tab-content-scroll' },
            _react2.default.createElement(
                'div',
                { className: 'tab-content' },
                children
            )
        )
    );
};

TabbedNavigation.propTypes = {
    tabs: _propTypes2.default.array.isRequired,
    location: _propTypes2.default.object.isRequired,
    children: _propTypes2.default.element,
    className: _propTypes2.default.string
};

exports.default = TabbedNavigation;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/TabbedNavigation.js
// module id = 1699
// module chunks = 0